/**
 * PokePage - Placeholder for poke feature
 */

import { ComingSoonPage } from './ComingSoonPage'

export function PokePage() {
  return <ComingSoonPage feature="Poke" icon="👋" />
}
